import React, { useContext, useEffect, useState } from 'react';
import '../css/Settings.css';
import { useNavigate } from 'react-router-dom';
import userApi from '../../api/UserApi.js';
import configurationApi from '../../api/ConfigurationApi';
import notify from 'devextreme/ui/notify';
import { useAppContext } from './AppContext';

const Logout = (props) => {
    const app = useAppContext();
    const navigate = useNavigate();
    const [state, setState] = useState({
        configuration: {},
        loggedOut: false,
    });

    useEffect(() => {
        userApi.clearToken();

        app.loggedIn = false;

        (async () => {
            let config = state.configuration;

            if (!state.configuration.oidcConfig) {
                config = await configurationApi.retrieveConfiguration();

                setState({
                    ...state,
                    configuration: config,
                    loggedOut: false
                });
            }

            if (config.useNIHLogin) {
                const token = userApi.getIDToken();
                let result = await userApi.logoutOIDC(token);

                if (!result)
                    notify("Error during NIH logout");
            }

            setState(prevState => ({
                ...prevState,
                loggedOut: true
            }));
        })();
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
            <h2>You have successfully logged out. Thank you for using eCamera.</h2>
        </div>
    )
}

export default Logout;
